var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 17,
    fill: "#fff",
    "aria-label": "Facebook Logo"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.095 5.825H4.699V4.179c0-.618.391-.762.667-.762h1.69V.7L4.728.69c-2.584 0-3.172 2.027-3.172 3.324v1.81H.062v2.8h1.494v7.923h3.143V8.625H6.82z"
  })));
};
export default SvgFacebook;